import { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";

interface DecimalInputProps {
    id?: string;
    value?: number;
    onChange: (value: number | undefined) => void;
    step?: number;
    placeholder?: string;
    readOnly?: boolean;
    error?: string;
    className?: string;
    decimalPlaces?: number;
}

export function DecimalInput({
    id,
    value,
    onChange,
    step = 0.01,
    placeholder = "0",
    readOnly,
    error,
    className,
    decimalPlaces,
}: DecimalInputProps) {
    const [inputValue, setInputValue] = useState("");

    useEffect(() => {
        setInputValue(value?.toString() ?? "");
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
    };

    const handleBlur = () => {
        if (inputValue === "") {
            onChange(undefined);
        } else {
            const parsed = parseFloat(inputValue);
            const rounded =
                decimalPlaces !== undefined
                    ? Math.round(parsed * Math.pow(10, decimalPlaces)) /
                      Math.pow(10, decimalPlaces)
                    : parsed;

            // Update the displayed value if rounding occurred
            if (decimalPlaces !== undefined) {
                setInputValue(rounded.toFixed(decimalPlaces));
            }

            onChange(rounded);
        }
    };

    const inputClassName = `${error ? "border-red-500" : ""} ${readOnly ? "bg-gray-50" : ""} ${className || ""}`;

    return (
        <div className="w-full">
            <Input
                id={id}
                type="number"
                step={step}
                value={inputValue}
                onChange={handleChange}
                onBlur={handleBlur}
                readOnly={readOnly}
                className={inputClassName}
                placeholder={placeholder}
            />
            {error && (
                <p className="text-xs text-red-600 mt-1 break-words w-full">
                    {error}
                </p>
            )}
        </div>
    );
}
